import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from 'environments/environment';


@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const user = this.authenticationService.userValue;
    const isLoggedIn = user && user.token;

    // check expiration of access token
    if (user !== null && user.token !== undefined) {
      if (this.tokenExpired(user.token)) {
        this.authenticationService.doLogout();
      }
    }

    // add auth header with jwt if user is logged in and request is to api url
    const isApiUrl = request.url.startsWith(environment.protocol + '://' + environment.hostName);
    if (isLoggedIn && isApiUrl) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${user.token}`
        }
      });
    }

    return next.handle(request);
  }

  private tokenExpired(token: string) {
    const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
    return expiry <= (Math.floor((new Date).getTime() / 1000));
  }
}
